import { networkMapping } from "../../web3/wagmiProvider"

const LEGENDARY_RARITY = "legendary"
const EPIC_RARITY = "epic"
const RARE_RARITY = "rare"
const UNCOMMON_RARITY = "uncommon"

const GOLDEN_BACKPACK = "golden"
const SILVER_NOTEBOOK = "silver"

const avgBSCBlockTime = 3; // 3 seconds
const secondsInOneWeek = 7 * 24 * 3600;
const secondsInOneMonth = 30 * 24 * 3600;   // 30 days
export const avgBlocksPerWeek = Math.floor(secondsInOneWeek / avgBSCBlockTime); // 201600
export const avgBlocksPerMonth = Math.floor(secondsInOneMonth / avgBSCBlockTime); // 201600

export const genesisChainId = networkMapping[process.env.REACT_APP_GENESIS_NETWORK];
export const pNFTChainId = networkMapping[process.env.REACT_APP_PNFT_NETWORK];

export const pNFT_RARITY = Object.freeze({
    [LEGENDARY_RARITY]: LEGENDARY_RARITY,
    [EPIC_RARITY]: EPIC_RARITY,
    [RARE_RARITY]: RARE_RARITY,
    [UNCOMMON_RARITY]: UNCOMMON_RARITY
})

export const pNFT_RARITY_ENUM = Object.freeze({
    [LEGENDARY_RARITY]: 1,
    [EPIC_RARITY]: 2,
    [RARE_RARITY]: 3,
    [UNCOMMON_RARITY]: 4
})

export const pNFT_RARITIES = [LEGENDARY_RARITY, EPIC_RARITY, RARE_RARITY, UNCOMMON_RARITY]

export const genesis_RARITY = Object.freeze({
    [GOLDEN_BACKPACK]: GOLDEN_BACKPACK,
    [SILVER_NOTEBOOK]: SILVER_NOTEBOOK
})

export const genesis_POINTS = Object.freeze({
    [GOLDEN_BACKPACK]: 4,
    [SILVER_NOTEBOOK]: 1
})

export const genesis_Requirement = {
    [pNFT_RARITY.legendary]: { [genesis_RARITY.silver]: 1, [genesis_RARITY.golden]: 1, points: 5 },
    [pNFT_RARITY.epic]: { [genesis_RARITY.silver]: 0, [genesis_RARITY.golden]: 1, points: 4 },
    [pNFT_RARITY.rare]: { [genesis_RARITY.silver]: 2, [genesis_RARITY.golden]: 0, points: 2 },
    [pNFT_RARITY.uncommon]: { [genesis_RARITY.silver]: 1, [genesis_RARITY.golden]: 0, points: 1 },
}

export const pNFT_MINT_PRICE_USD = 433;

// buy genesis 
// https://element.market/collections/opencampus-genesis

// genesis escrow
// 0x0a384ADA1805339f552dD1531dF8bF5b8Cf8A3AC
// token
// 0xC9C8D7c9a3584D770d89c3bA741f1F9F079962Fb

// pnft escrow
// 0xAc5D2631E91295c699315Ab4d5fE7ffa7E2Da5b3
// token
// 0x97e8eCE1FEAA8de3819CD6e7fED3776F12E87f70

// claim
// 0x4D9e456C201Ee82E2F454ec39BCEb70d635a1536

// safe transfer from encoded data
// const data = ethers.AbiCoder.defaultAbiCoder().encode(['address', 'uint256'], [erc721Address, erc721TokenId]);

// safe batch transfer from encoded data
// const data = ethers.AbiCoder.defaultAbiCoder().encode(['address[]', 'uint256[]', 'uint256[]', 'uint256[]'], [erc721Addresses, erc721TokenIds, erc1155TokenId1Quantities, erc1155TokenId2Quantities]);

